// Mock data for Pierre & Edois lagoon boat tour website

export const heroSlides = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1753818268536-b3227488c3f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxwaXJvZ3VlJTIwbGFnb29uJTIwYWZyaWNhfGVufDB8fHx8MTc4NzA1MTk0OHww&ixlib=rb-4.1.0&q=85',
    title: 'Le quai, juste avant',
    titleAccent: 'le départ',
    subtitle: 'Une aventure lagunaire unique au cœur du Bénin'
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1774960693005-e6a8aafc3397?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxtYW5ncm92ZSUyMHdhdGVyd2F5fGVufDB8fHx8MTc4NzA1MTk0OHww&ixlib=rb-4.1.0&q=85',
    title: 'Naviguez entre',
    titleAccent: 'mangroves',
    subtitle: 'Découvrez des paysages préservés'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1753818268681-2686059a4dc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxwaXJvZ3VlJTIwbGFnb29uJTIwYWZyaWNhfGVufDB8fHx8MTc4NzA1MTk0OHww&ixlib=rb-4.1.0&q=85',
    title: 'Traditions et',
    titleAccent: 'modernité',
    subtitle: 'Le meilleur des deux mondes'
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1660727265763-0455a2f6e2fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxib2F0JTIwbGFnb29uJTIwdG91cnxlbnwwfHx8fDE3ODcwNTE5NDh8MA&ixlib=rb-4.1.0&q=85',
    title: 'Un voyage',
    titleAccent: 'inoubliable',
    subtitle: 'Cotonou, Aguégué, Ganvié et au-delà'
  }
];

export const packages = [
  {
    id: 'essentielle',
    name: 'Essentielle',
    subtitle: 'Balade découverte',
    duration: '1 H',
    perPerson: 'PAR PERSONNE',
    price: '10 000',
    priceNote: 'F CFA / personne',
    stars: 1,
    popular: false,
    image: 'https://images.pexels.com/photos/35594683/pexels-photo-35594683.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    features: [
      'Idéale pour une première fois : simple et accessible à tous',
      'Vue depuis la lagune sur les institutions et les sites touristiques',
      'Balade le long de la côte, jusqu\'au pont de Porto-Novo',
      'Guide, gilet de sauvetage et eau fraîche'
    ],
    cta: 'Réserver Essentielle'
  },
  {
    id: 'avancee',
    name: 'Avancée',
    subtitle: 'Balade lagunaire',
    duration: '1 H 20',
    perPerson: 'PAR PERSONNE',
    price: '15 000',
    priceNote: 'à 25 000 F CFA / personne',
    priceExtra: '25 000 F à deux · 15 000 F à partir de 5 passagers',
    stars: 2,
    popular: true,
    image: 'https://images.unsplash.com/photo-1761471420566-5ca748e79afc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwYm9hdHxlbnwwfHx8fDE3ODcwNTE5NjV8MA&ixlib=rb-4.1.0&q=85',
    features: [
      'Balade complète avec pauses photo et ambiance conviviale',
      'Traversée du pont de Porto-Novo',
      'Accostage rapproché des sites touristiques',
      'Collation : jus et eau'
    ],
    cta: 'Réserver Avancée'
  },
  {
    id: 'premium',
    name: 'Premium',
    subtitle: 'Balade privée',
    duration: '2 H',
    perPerson: 'PAR PERSONNE',
    price: '30 000',
    priceNote: 'F CFA / personne',
    stars: 3,
    popular: false,
    image: 'https://images.unsplash.com/photo-1767364500436-c2db2971c776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxtYW5ncm92ZSUyMHdhdGVyd2F5fGVufDB8fHx8MTc4NzA1MTk0OHww&ixlib=rb-4.1.0&q=85',
    features: [
      'Itinéraire flexible : Cotonou, Aguégué, Ganvié et au-delà',
      'Balade personnalisée, parfaite pour les moments spéciaux',
      'Bouteille offerte',
      'Apéro à bord'
    ],
    cta: 'Réserver Premium'
  }
];

export const experiences = [
  {
    id: 1,
    icon: 'Compass',
    title: 'Guides locaux experts',
    description: 'Des guides passionnés qui connaissent la lagune comme leur poche.'
  },
  {
    id: 2,
    icon: 'ShieldCheck',
    title: 'Sécurité garantie',
    description: 'Gilets de sauvetage et embarcations aux normes pour toutes vos sorties.'
  },
  {
    id: 3,
    icon: 'Camera',
    title: 'Moments inoubliables',
    description: 'Des pauses photo aux endroits les plus emblématiques.'
  },
  {
    id: 4,
    icon: 'Leaf',
    title: 'Tourisme responsable',
    description: 'Nous préservons l\'écosystème lagunaire à chaque sortie.'
  }
];

export const gallery = [
  'https://images.unsplash.com/photo-1774960693005-e6a8aafc3397?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxtYW5ncm92ZSUyMHdhdGVyd2F5fGVufDB8fHx8MTc4NzA1MTk0OHww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1767917920882-dd37fb10e597?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxtYW5ncm92ZSUyMHdhdGVyd2F5fGVufDB8fHx8MTc4NzA1MTk0OHww&ixlib=rb-4.1.0&q=85',
  'https://images.pexels.com/photos/11308866/pexels-photo-11308866.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.unsplash.com/photo-1702236315790-0ffd668c5784?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxhZnJpY2FuJTIwYm9hdHxlbnwwfHx8fDE3ODcwNTE5NjV8MA&ixlib=rb-4.1.0&q=85',
  'https://images.pexels.com/photos/29395570/pexels-photo-29395570.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  'https://images.unsplash.com/photo-1656789294488-5d744838eda1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxhZnJpY2FuJTIwYm9hdHxlbnwwfHx8fDE3ODcwNTE5NjV8MA&ixlib=rb-4.1.0&q=85'
];

export const testimonials = [
  {
    id: 1,
    name: 'Aminata Diallo',
    location: 'Dakar, Sénégal',
    rating: 5,
    comment: 'Une expérience magique ! Le guide était passionné et les paysages à couper le souffle. La formule Avancée est un excellent rapport qualité-prix.',
    avatar: 'AD'
  },
  {
    id: 2,
    name: 'Julien Moreau',
    location: 'Paris, France',
    rating: 5,
    comment: 'Nous avons opté pour la balade Premium en famille. Un moment inoubliable, entre traditions et confort moderne. À refaire absolument !',
    avatar: 'JM'
  },
  {
    id: 3,
    name: 'Kofi Mensah',
    location: 'Cotonou, Bénin',
    rating: 5,
    comment: 'Enfin un service à la hauteur pour découvrir notre lagune. L\'équipe est professionnelle et les embarcations très confortables.',
    avatar: 'KM'
  }
];

export const faqs = [
  {
    question: 'Comment réserver une balade ?',
    answer: 'Vous pouvez réserver directement depuis notre site en cliquant sur le bouton "Réserver" de la formule qui vous intéresse, ou nous contacter via WhatsApp pour un accompagnement personnalisé.'
  },
  {
    question: 'Quels sont les horaires de départ ?',
    answer: 'Nos départs se font tous les jours de 7h à 17h. Nous recommandons les balades matinales pour profiter de la lumière et de la fraîcheur.'
  },
  {
    question: 'Que dois-je apporter ?',
    answer: 'Nous fournissons les gilets de sauvetage, l\'eau fraîche et parfois une collation. Pensez à apporter chapeau, crème solaire, appareil photo et vêtements légers.'
  },
  {
    question: 'Les enfants sont-ils autorisés ?',
    answer: 'Absolument ! Nos balades sont adaptées aux familles. Les enfants de moins de 5 ans voyagent gratuitement avec un adulte.'
  },
  {
    question: 'Quel est le nombre maximum de passagers ?',
    answer: 'Nos barques accueillent jusqu\'à 12 personnes maximum pour garantir sécurité et confort.'
  }
];

export const stats = [
  { value: '5000+', label: 'Passagers satisfaits' },
  { value: '4.9', label: 'Note moyenne' },
  { value: '12', label: 'Places par barque' },
  { value: '365', label: 'Jours par an' }
];
